import { render, staticRenderFns } from "./SiteSearch.vue?vue&type=template&id=5304e7c2&scoped=true&"
import script from "./SiteSearch.vue?vue&type=script&lang=js&"
export * from "./SiteSearch.vue?vue&type=script&lang=js&"
import style0 from "./SiteSearch.vue?vue&type=style&index=0&id=5304e7c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5304e7c2",
  null
  
)

export default component.exports